import type { AnalyticsAdapter } from './analyticsAdapter.ts'

export const INTERNAL_TOOLS_ANALYTICS_TEST_BRIDGE_WINDOW_KEY =
  '__INTERNAL_TOOLS_ANALYTICS_TEST_BRIDGE__' as const

export type AnalyticsLogType = keyof Pick<
  AnalyticsAdapter,
  'identify' | 'track' | 'pageView'
>

export interface AnalyticsLog {
  type: AnalyticsLogType
  timestamp: number
  /**
   * The **agentId** that was identified (Segment calls this `userId`).
   */
  agentId?: string
  event?: string
  screenName?: string
  properties?: Record<string, unknown>
}

export interface AnalyticsTestBridge {
  getLogs: () => AnalyticsLog[]
  clearLogs: () => void
  findEvent: (name: string) => AnalyticsLog | undefined
  findAllEvents: (name: string) => AnalyticsLog[]
  findIdentify: (agentId: string) => AnalyticsLog | undefined
  findAllIdentifies: (agentId: string) => AnalyticsLog[]
  findPageView: (screenName: string) => AnalyticsLog | undefined
  findAllPageViews: (screenName: string) => AnalyticsLog[]
}

declare global {
  /**
   * Augment `window` so the Mock analytics adapter can expose a typed test bridge.
   *
   * This lets Playwright (and unit tests) read analytics logs from the browser without
   * having to use `window as any`.
   *
   * It is only expected to exist when analytics runs in mock mode
   * (`VITE_ANALYTICS_ADAPTER=mock`).
   */
  interface Window {
    __INTERNAL_TOOLS_ANALYTICS_TEST_BRIDGE__?: AnalyticsTestBridge
  }
}
